import React, { useEffect, useState } from 'react';
import CourseTypeListing from './CourseTypeListing';
import { columnTypes } from 'src/components/UI/atoms/ATMTable/ATMTable';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { setIsOpenAddDialog, setPage, setRowsPerPage, setSearchValue, setIsTableLoading, setItems, setTotalItems, setIsOpenEditDialog } from 'src/redux/slices/CourseTypeSlice';
import { useChangeStatusCourseTypeByIdMutation, useDeleteCourseTypeByIdMutation, useGetAllCourseTypeDataQuery } from 'src/services/CourseTypeService';
import { showToast } from 'src/utils/showToaster';
import { showConfirmationDialog } from 'src/utils/showConfirmationDialog';
import ATMMenu from 'src/components/UI/atoms/ATMMenu/ATMMenu';
import AddCourseTypeWrapper from '../Add/AddCourseTypeWrapper';
import EditCourseTypeWrapper from '../Edit/EditCourseTypeWrapper';
import { usePermission } from 'src/hooks/usePermission';

type Props = {};

const CourseTypeListingWrapper = (props: Props) => {
    const dispatch = useDispatch();
    const { items, totalItems, page, rowsPerPage, searchValue, isOpenAddDialog, isOpenEditDialog, isTableLoading } =
        useSelector((state: RootState) => state.courseType);

    const [deleteCourseType] = useDeleteCourseTypeByIdMutation()
    const [changeStatusCourseType] = useChangeStatusCourseTypeByIdMutation()


    const [selectedCourseTypeId, setSelectedCourseTypeId] = useState<string>()
    const { data, isLoading, isFetching } = useGetAllCourseTypeDataQuery({
        limit: rowsPerPage,
        searchValue: searchValue,
        params: [
            "courseType",
        ],
        page: page,
        filterBy: [],
        dateFilter: {},
        orderBy: "createdAt",
        orderByValue: -1,
        isPaginationRequired: true,
    });

    // Setting Module Data
    useEffect(() => {
        if (isLoading || isFetching) {
            dispatch(setIsTableLoading(true));
        } else {
            dispatch(setItems(data?.data || []));
            dispatch(setIsTableLoading(false));
            dispatch(setTotalItems(data?.totalItem || 0));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, isLoading, isFetching]);

    const handleDeleteCourseType = (row: string) => {
        showConfirmationDialog({
            title: "Hands Up",
            text: "Are you sure want to delete this Course Type ?",
            icon: "question",
            showCancelButton: true,
            next: (result) => {
                if (result?.isConfirmed) {
                    deleteCourseType(row).then((res: any) => {
                        if (res.error) {
                            showToast("error", res?.error?.data?.message);
                        } else {
                            showToast("success", res?.data?.message);
                        }
                    });
                }
            },
        });
    };


    const handleChangeStatusCourseType = (row: string) => {
        showConfirmationDialog({
            title: "Hands Up",
            text: "Are you sure want to change status of this Course Type ?",
            icon: "question",
            showCancelButton: true,
            next: (result) => {
                if (result?.isConfirmed) {
                    changeStatusCourseType({ id: row }).then((res: any) => {
                        if (res.error) {
                            showToast("error", res?.error?.data?.message);
                        } else {
                            showToast("success", res?.data?.message);
                        }
                    });
                }
            },
        });
    };

const moduleName = "COURSE_TYPE";

const canEdit = usePermission(moduleName, "UPDATE");
const canDelete = usePermission(moduleName, "DELETE");
const canActive = usePermission(moduleName, "ACTIVE/DEACTIVE");

const columns: columnTypes[] = [
  { field: 'courseType', headerName: 'Course Type', flex: 'flex-[1_1_0%]' },
  {
    field: "action",
    headerName: "Actions",
    flex: "flex-[1_1_0%]",
    align:"center",
    extraClasses: "",
    renderCell: (row: any) => {
      const options = [];

      if (canEdit) {
        options.push({
          label: "Edit",
          onClick: () => {
            dispatch(setIsOpenEditDialog(true));
            setSelectedCourseTypeId(row?._id);
          },
        });
      }

      if (canActive) {
        options.push({
          label: "Active/Deactive",
          onClick: () => {
            handleChangeStatusCourseType(row?._id);
          },
        });
      }

      if (canDelete) {
        options.push({
          label: "Delete",
          onClick: () => {
            handleDeleteCourseType(row?._id);
          },
        });
      }

      return <ATMMenu options={options} />;
    },
  },
];


    return (
        <>
            <div>
                <CourseTypeListing
                    columns={columns}
                    rows={items}
                    paginationProps={{
                        isTableLoading,
                        totalItems,
                        page,
                        rowsPerPage,
                        searchValue,
                        setPage: (newPage) => dispatch(setPage(newPage)),
                        setRowsPerPage: (newRowsPerPage) => dispatch(setRowsPerPage(newRowsPerPage)),
                        setIsOpenAddDialog: (value) => dispatch(setIsOpenAddDialog(value)),
                        setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
                    }}
                />
            </div>
            {isOpenAddDialog ? (
                <AddCourseTypeWrapper
                    onClose={() => dispatch(setIsOpenAddDialog(false))}
                />
            ) : null}
            {isOpenEditDialog ? (
                <EditCourseTypeWrapper
                    onClose={() => dispatch(setIsOpenEditDialog(false))}
                    selectedCourseTypeId={selectedCourseTypeId || ""}
                />
            ) : null}
        </>
    );
};

export default CourseTypeListingWrapper;